import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import { POPULATION_OPTIONS } from '../SpeechTopics/config';
import { truncateForTableCell } from '../../shared/textPreview';
import { DeleteActionButton } from '../../shared/tabStyles';
import { formatDateTime, formatPopulation, toEpochMillis } from '../../shared/formatters';

export const createParagraphsTableConf = ({ onDelete }) => [
  {
    getDisplay: (item) => item.locale || '',
    name: 'Locale',
    textOptions: { withEllipsis: true },
    width: 85,
    sortable: true,
    sortValue: (item) => item.locale || '',
  },
  {
    getDisplay: (item) => truncateForTableCell({ text: item?.text, locale: item?.locale }),
    name: 'Paragraph Text',
    textOptions: { size: TEXT_SIZE.H4, color: TEXT_COLOR.DARK_BLUE, withEllipsis: true },
    sortable: true,
    sortValue: (item) => (item.text || '').trim(),
  },
  {
    getDisplay: (item) => (typeof item.wordCount === 'number' ? item.wordCount : ''),
    name: 'Word Count',
    textOptions: { align: 'center' },
    width: 110,
    sortable: true,
    sortValue: (item) => (typeof item.wordCount === 'number' ? item.wordCount : null),
  },
  {
    getDisplay: (item) => formatDateTime(item?.createdAt),
    name: 'Created At',
    textOptions: { withEllipsis: true },
    width: 170,
    sortable: true,
    sortValue: (item) => toEpochMillis(item?.createdAt),
  },
  {
    getDisplay: (item) => formatDateTime(item?.updatedAt),
    name: 'Updated At',
    textOptions: { withEllipsis: true },
    width: 170,
    sortable: true,
    sortValue: (item) => toEpochMillis(item?.updatedAt),
  },
  {
    getDisplay: (item) => formatPopulation(item.population, POPULATION_OPTIONS),
    name: 'Population',
    textOptions: { withEllipsis: true },
    width: 120,
    sortable: true,
    sortValue: (item) => (item.population || []).join(','),
  },
  {
    getDisplay: (item) => (
      <DeleteActionButton
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(item.id);
        }}
        title="Delete"
      >
        <DeleteIcon color="error" sx={{ fontSize: 22 }} />
      </DeleteActionButton>
    ),
    name: '',
    width: 40,
  },
];
